/**
 * CARD.TSX
 */

import { WithTranslation, withTranslation } from "react-i18next";
import { useState } from "react";
import localeEmoji from "locale-emoji";
import languages from "@/translate/lang.json";

const flagImages: Record<string, string> = {
  en: require("@/translate/flags/en.png"),
  fr: require("@/translate/flags/fr.png"),
};

interface OwnProps {
  language: string;
  languages: string[];
  onChange?: Function;
}

type Props = OwnProps & WithTranslation;

function LanguageSelector(props: Props) {
  const { t } = props;
  const [currentLanguage, setCurrentLanguage] = useState<string>(
    props.language,
  );
  const availableLanguages = props.languages.map((lg) =>
    languages.find((language) => language.code === lg),
  );
  const useFlagImages = availableLanguages.every((language) => language?.qvFlag);

  function change(newLanguage: string) {
    setCurrentLanguage(newLanguage);
    if (props.onChange) {
      props.onChange(newLanguage);
    }
  }

  function getEmoji(lg: string) {
    if (lg === "en") return "🇬🇧";
    const emoji = localeEmoji(lg);
    return emoji ? emoji : lg.toUpperCase();
  }

  function getFlagImage(lg: string) {
    return flagImages[lg] ?? null;
  }

  function renderLanguageIcon(lg: string) {
    if (useFlagImages) {
      const flag = getFlagImage(lg);
      if (flag) {
        return (
          <span className="intro-language-flag">
            <img alt="" src={flag} />
          </span>
        );
      }
    }

    return getEmoji(lg);
  }

  // Si plus de 15 langues -> menu déroulant
  if (props.languages.length > 15) {
    return (
      <div>
        <div style={{ marginBottom: 8, fontWeight: 600 }}>
          {t("language_select")}
        </div>
        <select
          className="_hover"
          value={currentLanguage}
          style={{
            color: "white",
            backgroundColor: "initial",
            borderColor: "white",
            borderRadius: 8,
            padding: "4px 8px",
            fontWeight: "bold",
            fontSize: 16,
            cursor: "pointer",
          }}
          onChange={(e) => change(e.target.value)}
        >
          {props.languages.map((lg: string) => (
            <option key={lg} value={lg} style={{ color: "black" }}>
              {getEmoji(lg)} {languages.find((x) => x.code === lg)?.nativeName}
            </option>
          ))}
        </select>
        <div className="flex1" />
      </div>
    );
  }

  // Sinon -> affichage des boutons
  return props.languages.length > 1 ? (
    <div className="flex flex-wrap gap-2">
      {props.languages.map((lg: string) => (
        <div
          key={lg}
          onClick={() => change(lg)}
          style={
            currentLanguage === lg
              ? {
                  fontWeight: "bold",
                  backgroundColor: "#3f3f3f",
                  padding: "0px 8px",
                  borderRadius: 8,
                }
              : {}
          }
          className="_hover intro-language cursor-pointer"
        >
          {renderLanguageIcon(lg)}
          <span>{lg.toUpperCase()}</span>
        </div>
      ))}
    </div>
  ) : (
    <div style={{ height: 10 }} />
  );
}

export default withTranslation()(LanguageSelector);
